<template>
	<v-app id="inspire">
		<v-navigation-drawer v-model="drawer" class="pt-lg-12" dark app>
			<v-list dense>
				<v-list-item link :to="{name: 'plansList'}">
					<v-list-item-content>
						<v-list-item-title>
							User plans
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item link :to="{name: 'sessionsList'}">
					<v-list-item-content>
						<v-list-item-title>
							Sessions
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item link :to="{name: 'sectionsList'}">
					<v-list-item-content>
						<v-list-item-title>
							Sections
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item link :to="{name: 'import'}">
					<v-list-item-content>
						<v-list-item-title>
							Import All
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-content class="pb-12">
			<v-container class="fill-height align-start" fluid>
				<v-row v-if="$route.name === 'Admin'">
					<v-col cols="3">
						<v-card>
						</v-card>
					</v-col>
				</v-row>
				<v-row v-else>
					<v-col class="text-center">
						<router-view />
					</v-col>
				</v-row>
			</v-container>
		</v-content>

	</v-app>
</template>

<script>
	export default {
		props: {
			source: String,
		},
		data: () => ({
			drawer: null,
		}),
	}
</script>

<style lang="scss">
	.action-wrapper{
		position: fixed;
		bottom: 10px;
		right: 10px;
	}
</style>
